var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SideMenu",class:{ menuActive: _vm.isActive }},[_c('div',{staticClass:"overlay_container",on:{"click":_vm.menuToggler}}),_c('SideMenuLinks',{attrs:{"menuToggler":_vm.menuToggler,"isActive":_vm.isActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }